import Radio from "backbone.radio";

import ModalFormLayout from "../../../generic/form-layout";
import Body from "./form-body";
import Buttons from "../../../generic/button/collection";
import buttons from "./form-buttons";

import FormModel from "../../../../models/admin/account";

const channel = Radio.channel("global");

const DEFAULTS = {
  className: "form-horizontal",
};

class FormBody extends ModalFormLayout {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);

    this.formModel = new FormModel();
  }

  events() {
    return {
      submit: "_onSubmit",
    };
  }

  onBeforeRender() {
    const { roles } = this.options.setupData;

    // overwrite model roles with full set
    this.model.setRoles(roles);
  }

  onBeforeShow() {
    // attach form fields
    this.body.show(
      new Body({
        model: this.model,
      })
    );

    // attach form buttons
    this.buttons.show(
      new Buttons({
        buttons,
        meta: this.options,
      })
    );
  }

  _onSubmit(e) {
    // prevent default behavior
    e.preventDefault();

    // extract submitted form data
    const formData = {
      username: this.$("input[name=username]")[0].value,
      ciamUserId: this.$("input[name=ciamUserId]")[0].value,
      firstName: this.$("input[name=firstName]")[0].value,
      lastName: this.$("input[name=lastName]")[0].value,
      enabled: this.$("input:checkbox[name=enabled]")[0].checked,
      visible: this.$("input:checkbox[name=visible]")[0].checked,
      roles: this.options.setupData.roles.clone(),
    };

    // special handling for roles checkboxes
    const $roles = this.$("input:checkbox[name=roles]:checked");

    formData.roles = $roles.get().map((role) => +role.value);

    // apply form data to current model
    this.formModel.set(formData);

    // prepare sync callbacks
    this.listenToOnce(this.formModel, "sync", this._onModelSync);
    this.listenToOnce(this.formModel, "error", this._onModelSyncFailure);

    // persist model
    this.formModel.save();
  }

  _onModelSync() {
    // dismiss the parent modal
    this.triggerMethod("dismiss:modal");

    // display success message
    channel.trigger("status:show", {
      type: "success",
      message: "The account has been created.",
    });
  }

  _onModelSyncFailure(model, xhr) {
    // dismiss the parent modal
    this.triggerMethod("dismiss:modal");

    console.warn("[%s] Unable to create account.", xhr.status);

    // display error message
    channel.trigger("status:show", {
      autoDismiss: false,
      type: "danger",
      message: "The account could not be created. Please try again later.",
    });
  }
}

export { FormBody as default };
